export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const MARK_SINGLE_NOTIFICATION_READ = 'MARK_SINGLE_NOTIFICATION_READ';
export const MARK_SEEN_NOTIFICATIONS = 'MARK_SEEN_NOTIFICATIONS';
export const RECEIVE_NOTIFICATION = 'RECEIVE_NOTIFICATION';
